const raceRoadmapParams = {
        filter : "filters[race_link][$eq]=",
        populate: "&populate=%2A",
}

export default raceRoadmapParams